export default __webpack_public_path__ + "static/media/wa-logo.7f2d5555.png";